export default "__VITE_ASSET__F32Sv2eE__"